module.exports = __webpack_public_path__ + "img/live-watch.da635faf.png";